// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"5584":"solution-page-container","8912":"manage-apps"}[chunkId] || chunkId) + ".chunk.min.js";
};